// import React from 'react';
// import XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// const ExcelExport = ({ applicants }) => {
//   // Check if applicants or rows is undefined or null
//   if (!applicants || !applicants.rows) {
//     return null; // Or show a loading message or something appropriate
//   }

//   const exportToExcel = () => {
//     const data = applicants.rows.map((applicant) => ({
//       Name: applicant.firstname || '',
//       Gender: applicant.gender || '',
//       Education: applicant.education || '',
//       Mobile: applicant.mobile || '',
//       Email: applicant.email || '',
//       Status: applicant.counselling_status === '1'
//         ? 'Applied'
//         : applicant.counselling_status === '3'
//         ? 'Shortlisted'
//         : '',
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Candidates');

//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const file = new Blob([excelBuffer], { type: 'application/octet-stream' });

//     saveAs(file, 'Selected_candidates.xlsx');
//   };

//   return (
//     <button className="btn btn-primary" onClick={exportToExcel}>
//       Download Excel
//     </button>
//   );
// };

// export default ExcelExport;

import React from 'react';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelExport = ({ applicants, t }) => {
    // Check if applicants or rows are undefined or null
    if (!applicants || !applicants.rows || !applicants.rows.length) {
        return null; // Or show a loading message
    }

    const exportToExcel = () => {
        const data = applicants.rows.map((applicant) => ({
            Name: applicant.firstname || '',
            Gender: applicant.gender || '',
            Education: applicant.education || '',
            Mobile: applicant.mobile || '',
            Email: applicant.email || '',
            Status: applicant.counselling_status === '1'
                ? 'Applied'
                : applicant.counselling_status === '3'
                    ? 'Shortlisted'
                    : '',
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Candidates');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const file = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(file, 'Selected_candidates.xlsx');
    };

    return (
        <div className="row pl-3 pr-3">
            {applicants.rows.length ? (
                <>
                    <h6 className="mr-3">
                        {t('counsellingProvider.session_name', { param: 'react' })}: <b>{applicants.rows[0].session_name}</b>
                    </h6>
                    {/* <h6 className="mr-3">
                        {t('counsellingProvider.seat', { param: 'react' })}: <b>{applicants.rows[0].seat}</b>
                    </h6> */}
                    {/* <h6 className="mr-3">
                        {t('counsellingProvider.sessionMode', { param: 'react' })}: <b>{applicants.rows[0].mode}</b>
                    </h6> */}
                    <h6 className="mr-3">
                        {/* Add export button */}
                        <button aria-label="Download Excel" className="btn btn-primary btn-primary2 pull-right" onClick={exportToExcel} style={{ cursor: "pointer" }}>
                            {t('counsellingProvider.downloadExcelInst1', { param: 'react' })}
                        </button>
                    </h6>
                </>
            ) : null}
        </div>
    );
};

export default ExcelExport;

